import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "EC_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#EC_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#2E42A5"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "EC_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#EC_svg__b)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v12h32V0H0z",
      fill: "#FECA00"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 18v6h32v-6H0z",
      fill: "#E31D1C"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.719 5.714s4.156-1.877 4.534-1.664c.377.213.469.821.795.821.326 0 .982-.192 1.257-.192.274 0 .545.192.545.192h1.17v-.65l5.309 1.493s-3.096.405-3.33.405c-.233 0 0 .333 0 .333s-.441-.333-1.114-.333c-.672 0-2.035.694-2.035.694l.495 1.067-.495.313-.545-.313s.035-.877-.2-.877c-.235 0-.406.563-.406.877 0 .313-.651.313-.651.313l.29-.587s.29-.973-.29-.973-3.225-.514-3.225-.514l-.676.333.242-.738h-1.67z",
      fill: "#7B2900"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.505 15.775c-.649-1.458 0-4.688 0-4.688l1.26.661c-.149.754-.172 2.178.3 3.343.471 1.165 2.255 2.083 2.255 2.083s.9.2-.468.345c-1.367.144-2.698-.286-3.347-1.744zm3.23 5.742c-.406 0 .813-2.709.813-2.709l.376-.752s.046 3.188-.212 3.461c-.165.175-.353.126-.573.068-.124-.033-.258-.068-.404-.068z",
      fill: "#E31D1C"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.328 15.298c-.543-2.177.305-5.133.305-5.133l.853.61c-.125 1.125-.125 4.036.596 5.297.722 1.262 3.888 1.791 3.888 1.791s-.625.462-1.77.678c-1.145.216-3.328-1.066-3.872-3.243zm3.63 5.919l.502-1.793.707-.865h.51s-.717 3.08-1.217 3.08c-.325 0-.228-.178-.12-.376.059-.107.12-.22.12-.313 0-.267-.502.267-.502.267z",
      fill: "#2E42A5"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.501 15.671c-.27-1.873.27-6.35.27-6.35l.853.609c-.385 1.085-.266 4.196 0 5.741s2.786 2.477 2.786 2.477-.625.462-1.77.677c-1.145.216-1.869-1.28-2.139-3.154zm4.188 3.745c-.486 0 .212-.696.212-.696h1.163s-.398.984-.89.984c-.245 0-.245-.073-.244-.145 0-.071.001-.143-.241-.143z",
      fill: "#FECA00"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20.366 15.775c.649-1.458 0-4.688 0-4.688l-1.26.661c.149.754.172 2.178-.3 3.343-.471 1.165-2.255 2.083-2.255 2.083s-.9.2.468.345c1.367.144 2.698-.286 3.347-1.744zm-3.23 5.742c.406 0-.813-2.709-.813-2.709l-.376-.752s-.046 3.188.212 3.461c.165.175.353.126.574.068.123-.033.257-.068.403-.068z",
      fill: "#E31D1C"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21.543 15.298c.543-2.177-.305-5.133-.305-5.133l-.853.61c.125 1.125.125 4.036-.596 5.297-.722 1.262-3.888 1.791-3.888 1.791s.625.462 1.77.678c1.145.216 3.328-1.066 3.872-3.243zm-3.63 5.919l-.502-1.793-.707-.865h-.51s.717 3.08 1.217 3.08c.325 0 .228-.178.12-.376-.058-.107-.12-.22-.12-.313 0-.267.502.267.502.267z",
      fill: "#2E42A5"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22.37 15.671c.27-1.873-.27-6.35-.27-6.35l-.853.609c.386 1.085.266 4.196 0 5.741s-2.786 2.477-2.786 2.477.625.462 1.77.677c1.145.216 1.87-1.28 2.139-3.154zm-4.188 3.745c.486 0-.212-.696-.212-.696h-1.163s.398.984.89.984c.245 0 .245-.073.244-.145 0-.071-.001-.143.241-.143z",
      fill: "#FECA00"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M10.203 10.446l.092-.553 1.6.104-1.214-1.258.41-.39 1.642 1.702-1.404-2.64.485-.289 1.278 1.88-.61-1.954.525-.208 1.966 3.92-.755-.049.074.237.642.17-.146.543-.298-.078.278.89-.482-.71.84 1.58-2.066-2.14-2.857-.757zM21.926 10.446l-.092-.553-1.6.104 1.214-1.258-.41-.39-1.642 1.702 1.404-2.64-.485-.289-1.279 1.88.61-1.954-.524-.208-1.966 3.92.754-.049-.073.237-.642.17.146.543.297-.078-.278.89.483-.71-.84 1.58 2.066-2.14 2.857-.757z",
      fill: "#6FAE21"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M11.067 21.311l-.413-.385L22.844 8.09l.413.386-12.19 12.834z",
      fill: "#171401"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22.535 8.19l.625.59.352-.975-.977.385zM11.376 21.309l-.718-.472-.233.967.95-.495z",
      fill: "#CECECC"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M10.16 19.398l-.412-.386 12.19-12.834.413.386-12.19 12.834z",
      fill: "#171401"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21.629 6.277l.625.589.352-.974-.977.385zM10.47 19.396l-.719-.472-.232.967.95-.495z",
      fill: "#CECECC"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M21.256 21.311l.412-.385L9.478 8.09l-.413.386 12.19 12.834z",
      fill: "#171401"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.787 8.19l-.625.59-.352-.975.977.385zM20.947 21.309l.718-.472.232.967-.95-.495z",
      fill: "#CECECC"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M22.39 19.849l.413-.386-12.19-12.835-.413.386 12.19 12.835z",
      fill: "#171401"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.922 6.727l-.625.59-.352-.975.977.385zM22.081 19.846l.718-.472.233.968-.95-.496z",
      fill: "#CECECC"
    }
  ), /* @__PURE__ */ e.createElement("path", { fill: "#B74E01", d: "M13.668 16.375h4.533v2.25h-4.533z" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M15.949 17.287c.898 0 1.675-.578 2.215-1.435.541-.86.868-2.033.868-3.315s-.327-2.455-.868-3.315c-.54-.857-1.317-1.435-2.215-1.435-.9 0-1.676.578-2.216 1.435-.541.86-.868 2.033-.868 3.315s.327 2.455.868 3.315c.54.857 1.317 1.435 2.216 1.435z",
      fill: "#7DB8FF",
      stroke: "#FECA00",
      strokeWidth: 0.5
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "EC_svg__c",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 12,
      y: 7,
      width: 8,
      height: 11
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M15.949 17.287c.898 0 1.675-.578 2.215-1.435.541-.86.868-2.033.868-3.315s-.327-2.455-.868-3.315c-.54-.857-1.317-1.435-2.215-1.435-.9 0-1.676.578-2.216 1.435-.541.86-.868 2.033-.868 3.315s.327 2.455.868 3.315c.54.857 1.317 1.435 2.216 1.435z",
        fill: "#fff",
        stroke: "#fff",
        strokeWidth: 0.5
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#EC_svg__c)", fillRule: "evenodd", clipRule: "evenodd" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.881 12.61h1.612s1.109.245.554.439c-.554.193-.554.257-.554.532v1.5c0 .215.395.676-.436.676S12.51 12.34 12.51 12.34l.371.269zM19.18 12.796s-1.498.296-2.524.197c-1.026-.098-1.476-.197-1.476-.197s.715.372.969.684c.254.311.774.85 1.305.85.53 0 1.344.503 1.344.503l.382-2.037z",
      fill: "#6FAE21"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M13.32 10.136s1.235.238 1.532.596c.297.357-.393.714 1.406.357 1.8-.357 3.227-.98 3.227 0s-.157 1.884-.931 1.884H15.11c-2.36 0-3.648.722-3.482-.44.165-1.162 1.692-2.397 1.692-2.397z",
      fill: "#F7FCFF"
    }
  ))))
);
export {
  t as default
};
